import { Product } from '../../types/Product';

interface OverallStats {
  totalProducts: number;
  averagePrice: number;
  productTrend: number;
  priceTrend: number;
  totalCategories: number;
  categoryTrend: number;
}

export const calculateOverallStats = (products: Product[]): OverallStats => {
  const totalProducts = products.length;
  const totalPrice = products.reduce((sum, p) => sum + p.current_price, 0);
  const averagePrice = totalPrice / totalProducts;

  const uniqueCategories = new Set(products.map(p => p.category_name)).size;

  // Mock trends for now - in a real app these would come from historical data
  const productTrend = 5.2;
  const priceTrend = -2.1;
  const categoryTrend = 1.5;

  return {
    totalProducts,
    averagePrice,
    productTrend,
    priceTrend,
    totalCategories: uniqueCategories,
    categoryTrend
  };
};